/*
 * Mobile - Blog - Trending Collections  --  variant: Bottom Of Article
 * Moonshot experiment id: 59204444   status in Moonshot on 2026-08-27: DEPLOYED   started: 2025-10-27
 * Audience: MOBILE   Target: blog   (see MGExp.targets in mg-exp-runtime.js)
 * Source: verbatim variant code from cdn.moonshot-ai.com/snippets/36780565.js (prettified);
 *         only change is window.msaiTools._msaiRunVariantBlock -> MGExp.runVariantBlock.
 * Enabled by theme setting: mgexp_blog_m_trending_collections
 */
MGExp.run('blog_m_trending_collections', { name: "Mobile - Blog - Trending Collections / Bottom Of Article", platform: 'mobile', target: 'blog' }, function () {
  !(function () {
    let e = [
        ".msai-trending-collections-container .collection-item",
        ".msai-trending-collections-container .image-container",
        ".msai-trending-collections-container .collection-image",
        ".msai-trending-collections-container .collection-name",
      ],
      o = [];
    !(async function (t, n, i, c, a) {
      let l = {
        multi_target_selectors: e,
        page_identifier_selector: "#shopify-section-new-blog-show",
        exclude_from_timeout: o,
        selector_timeout: 5e3,
      };
      await MGExp.runVariantBlock(t, n, i, c, a, l);
    })(
      ["#shopify-section-new-blog-show"],
      ".msai-trending-collections-added",
      function (e, o) {
        const [t] = o,
          n = [
            {
              path: "/collections/under-250",
              name: "Under $250",
              imageUrl:
                "https://mygemma.com/cdn/shop/collections/luxury_under_250.png?v=1759513922",
            },
            {
              path: "/collections/under-500",
              name: "Under $500",
              imageUrl:
                "https://mygemma.com/cdn/shop/collections/under-500.jpg?v=1715888063",
            },
            {
              path: "/collections/louis-vuitton-bags-under-1000",
              name: "Louis Vuitton Under $1,000",
              imageUrl:
                "https://mygemma.com/cdn/shop/collections/louis-vuitton-bags-under-1000_e6ed1749-d606-4511-909b-a1184628628d.jpg?v=1719435463",
            },
            {
              path: "/collections/chanel-under-2-000",
              name: "Chanel Under $2,000",
              imageUrl:
                "https://mygemma.com/cdn/shop/collections/Chanel_Under_2_000.jpg?v=1720799028",
            },
            {
              path: "/collections/sale",
              name: "Sale",
              imageUrl:
                "https://mygemma.com/cdn/shop/collections/designer-bag-sale_3328feac-2980-497e-8ea9-59cee38520fc.jpg?v=1716820410",
            },
            {
              path: "/collections/try-before-you-buy",
              name: "Try Before You Buy",
              imageUrl:
                "https://mygemma.com/cdn/shop/collections/silver_designer_jewelry_david_yurman.png?v=1745254139",
            },
          ],
          i = document.createElement("div");
        i.className = "msai-trending-collections-container";
        const c = document.createElement("h2");
        ((c.className = "msai-trending-title"),
          (c.innerHTML = "Discover Accessible Luxury"),
          i.appendChild(c));
        const a = document.createElement("div");
        ((a.className = "msai-collections-scroll"),
          n.forEach((e) => {
            const o = document.createElement("a");
            ((o.className = "collection-item"), (o.href = e.path));
            const t = document.createElement("div");
            t.className = "image-container";
            const n = document.createElement("img");
            ((n.className = "collection-image"),
              (n.src = e.imageUrl),
              (n.alt = e.name),
              (n.loading = "lazy"));
            const i = document.createElement("div");
            ((i.className = "collection-name"),
              (i.textContent = e.name),
              t.appendChild(n),
              o.appendChild(t),
              o.appendChild(i),
              a.appendChild(o));
          }),
          i.appendChild(a));
        const l = document.createElement("div");
        l.className = "msai-carousel-dots";
        const s = () => {
            const e = a.clientWidth,
              o = Math.floor(e / 200),
              t = n.length;
            return Math.max(1, Math.ceil(t - o + 1));
          },
          r = (e) => {
            l.innerHTML = "";
            for (let o = 0; o < e; o++) {
              const e = document.createElement("div");
              ((e.className = "msai-carousel-dot"),
                0 === o && e.classList.add("active"),
                e.addEventListener("click", () => {
                  const e = a.clientWidth,
                    t = (Math.floor(e / 200), 200 * o);
                  a.scrollTo({ left: t, behavior: "smooth" });
                }),
                l.appendChild(e));
            }
          },
          d = () => {
            const e = a.scrollLeft,
              o = Math.round(e / 200);
            l.querySelectorAll(".msai-carousel-dot").forEach((e, t) => {
              t === o ? e.classList.add("active") : e.classList.remove("active");
            });
          };
        (a.addEventListener("scroll", d),
          setTimeout(() => {
            const e = s();
            (r(e),
              window.addEventListener("resize", () => {
                const e = s();
                (r(e), d());
              }));
          }, 100),
          i.appendChild(l),
          t.nextSibling
            ? t.parentNode.insertBefore(i, t.nextSibling)
            : t.parentNode.appendChild(i),
          t.classList.add("msai-trending-collections-added"));
      },
      ".msai-trending-collections-container{padding:20px 15px;margin-bottom:10px;background-color:#fff}.msai-trending-title{font-family:'Playfair Display',sans-serif;font-size:28px;font-weight:400;margin-bottom:15px;text-align:center;color:#333}.msai-collections-scroll{display:flex;overflow-x:auto;scroll-behavior:smooth;-webkit-overflow-scrolling:touch;scrollbar-width:none;padding-bottom:10px}.msai-collections-scroll::-webkit-scrollbar{display:none}.msai-trending-collections-container .collection-item{flex:0 0 auto;width:180px;margin-right:20px;text-decoration:none;color:inherit}.msai-trending-collections-container .image-container{width:180px;height:180px;border-radius:8px;overflow:hidden;margin-bottom:8px;box-shadow:0 2px 8px rgba(0,0,0,0.1)}.msai-trending-collections-container .collection-image{width:100%;height:100%;object-fit:cover;transition:transform 0.3s ease}.msai-trending-collections-container .collection-item:hover .collection-image{transform:scale(1.05)}.msai-trending-collections-container .collection-name{font-size:14px;text-align:center;font-weight:500;color:#333;margin-top:5px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.msai-carousel-dots{display:flex;justify-content:center;margin-top:15px;gap:8px}.msai-carousel-dot{width:8px;height:8px;border-radius:50%;background-color:#ddd;cursor:pointer;transition:background-color 0.3s ease}.msai-carousel-dot.active{background-color:#333}",
    );
  })();
});
